import { State } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/store'
import { CampaignStepActivateData } from 'modules/campaigns/campaign-steps/types/campaign-step-interface'
import { CampaignStepActivateViewInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-view-interface'
import { TimeType } from 'shared/components/date-picker/time-delay-picker/constants'
import { convertSecondsToTimeValue } from 'shared/components/date-picker/time-delay-picker/utils'
import {
  chosenWeekdaysForBackend,
  chosenWeekdaysForFrontend,
} from 'shared/components/date-picker/weekdaysPicker/utils'

export const transformActivateDataForBackend = ({
  afterCampaignStepName,
  chosenTimeDelay,
  chosenSendingEmailTime,
  chosenWeekdays,
}: State): CampaignStepActivateData => {
  return {
    stepBefore: afterCampaignStepName,
    delayValue: chosenTimeDelay.selectedTimeValue,
    delayUnit: chosenTimeDelay.selectedTimeType,
    timeOfTheDay: chosenSendingEmailTime,
    excludedWeekdays: chosenWeekdaysForBackend(chosenWeekdays),
  }
}

export const transformCampaignStepDataToActivateData = (
  campaignStepData: CampaignStepActivateViewInterface,
): CampaignStepActivateData | null => {
  const { stepBefore, delayFromPreviousStep, timeOfTheDay, excludedWeekdays } = campaignStepData

  if (delayFromPreviousStep === null) return null

  const { timeType, timeValue } = convertSecondsToTimeValue(delayFromPreviousStep)

  return {
    stepBefore: stepBefore?.id ?? null,
    timeOfTheDay,
    delayValue: timeValue,
    delayUnit: timeType,
    excludedWeekdays,
  }
}

export const transformCampaignStepActivateDataToState = (
  campaignStepActivateData?: CampaignStepActivateData | null,
) => {
  const { stepBefore, timeOfTheDay, excludedWeekdays, delayValue, delayUnit } =
    campaignStepActivateData || {}

  return {
    afterCampaignStepName: stepBefore || null,
    chosenTimeDelay: {
      selectedTimeType: delayUnit ?? TimeType.DAYS,
      selectedTimeValue: delayValue ?? 0,
    },
    chosenSendingEmailTime: timeOfTheDay ?? null,
    chosenWeekdays: chosenWeekdaysForFrontend(excludedWeekdays),
  }
}
